import { render, staticRenderFns } from "./VInteractionHistory.vue?vue&type=template&id=6200e3e4&"
import script from "./VInteractionHistory.vue?vue&type=script&lang=js&"
export * from "./VInteractionHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports